import React, { PureComponent, Fragment } from 'react';
import Months from './components/months';
import Continents from './components/continents';
import TravelStyle from './components/travelstyle';
import Country from './components/country';
import Duration from './components/duration';
import Budget from './components/budget';

class FilterGroup extends PureComponent {


  renderMobileFilter(){
    if(this.props.filterName === "filterModalGroup-mobile"){
      return (
        <Fragment>
          <Duration active={this.props.active}  onSelect={this.props.onDurationSelect}/>
          <Budget active={this.props.active} onSelect={this.props.onBudgetSelect} currency={this.props.currency} currencyReady={this.props.currencyReady}/>
        </Fragment>
      )
    }
  }

  render(){
    return (
      <div className={this.props.filterName}>
        <Months onSelect={this.props.onMonthSelect} departureDates={this.props.departureDates} months={this.props.months} nextYearMonths={this.props.nextYearMonths} />
        <Continents active={this.props.active} onSelect={this.props.onContinentSelect} data={this.props.continentData} />
        <TravelStyle active={this.props.active} onSelect={this.props.onTravelStyleSelect} data={this.props.travelStyleData} />
        <Country active={this.props.active} onSelect={this.props.onCountrySelect} data={this.props.countryData} />

        {this.renderMobileFilter()}
      </div>
    )
  }

}

export default FilterGroup;



// WEBPACK FOOTER //
// ./src/components/search/components/filters/filtergroup.js